// extracted by mini-css-extract-plugin
export var bodyRow = "_g9-d";
export var cardColumns = "_g9-e";
export var ellipsesOverflow = "_g9-2";
export var flatBottomCorners = "_g9-3";
export var flatTopCorners = "_g9-4";
export var headerActionsDropdown = "_g9-f";
export var headerBottomRow = "_g9-c";
export var headerTopRow = "_g9-b";
export var orderDetailsWrapper = "_g9-0";
export var orderInfoContainer = "_g9-1";
export var productDetails = "_g9-9";
export var productImage = "_g9-5";
export var responsiveTable = "_g9-8";
export var shipmentContainer = "_g9-a";
export var tableBottomLeft = "_g9-6";
export var tableBottomRight = "_g9-7";
export var trackingLink = "_g9-g";